import { api, apiEndpoint } from "@core/ports/http";
import { z } from "@core/zod";

import { API_DOMAIN } from "@platform/core";

import { Taxonomy } from "@apis/taxonomy/models";

import { MEDIA_SERVICE } from "../config/index.ts";

export const mediaApi = api(
  { domain: API_DOMAIN, path: `${MEDIA_SERVICE.LABEL}/api` },
  {
    createTaxonomy: apiEndpoint({
      body: Taxonomy.createSchema.omit({
        controllerPrincipalId: true,
        principalId: true,
      }),
      response: z.object(
        { taxonomy: Taxonomy.schema },
        { taxonomy: "The taxonomy created for the user's media" },
      ),
    }),
    getMyTaxonomies: apiEndpoint({
      response: z.object(
        { items: z.array(Taxonomy.schema) },
        { items: "The user's media taxonomies" },
      ),
    }),
  },
);
